import {activeClass, openClass} from "../settings/settings";

$(document).ready(function() {
  let filter = $('#js-filter'),
    card = $('#js-card'),
    list = $('#js-list'),
    listWrapper = $('#js-search-results .item-list'),
    sellerListWrapper = $('#js-seller-results .item-list'),
    filterOrder = $('#js-search-filter-order');

  filter.click(function(e) {
    e.preventDefault();

    $(this).toggleClass(activeClass);
    filterOrder.toggleClass(openClass);

    return false;
  });

  card.click(function(e) {
    e.preventDefault();

    $(this).addClass(activeClass);
    list.removeClass(activeClass);
    listWrapper.removeClass('list-display');
    sellerListWrapper.removeClass('list-display');
    return false;
  });

  list.click(function(e) {
    e.preventDefault();

    $(this).addClass(activeClass);
    card.removeClass(activeClass);
    listWrapper.addClass('list-display');
    sellerListWrapper.addClass('list-display');
    return false;
  });

  if ($('#dressing_filter_sort').length) {
    $('#dressing_filter_sort').bind('change', function() {
      var $form = $(this).closest('form');
      $form.find('button[type=submit]').click();
    });
  }

  if ($('#change_user_onHoliday').length) {
    $('#change_user_onHoliday').bind('click', function() {
      var $form = $(this).closest('form');
      $form.find('button[type=submit]').click();
    });
  }
});

// Adding loading management for categories list in filter sidebar
window.onload = function() {
  const categoriesList = document.querySelector('.search-filter-container');
  const loadingObserver = document.getElementById('js-observer-result');

  if (categoriesList === null || loadingObserver === null) {
    return;
  }

  if (categoriesList.classList.contains('is-loading')) {
    categoriesList.classList.remove('is-loading');
  }

  const config = { attributes: true };
  const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
          const { target } = mutation;

          if (mutation.attributeName === 'class') {
              if (loadingObserver.classList.contains('is-loading')) {
                categoriesList.classList.add('is-loading');
              } else {
                categoriesList.classList.remove('is-loading');
              }
          }
      });
  });

  observer.observe(loadingObserver, config);
};

